import { render } from "./AddUsersToGroup.vue?vue&type=template&id=008f0984&scoped=true"
import script from "./AddUsersToGroup.vue?vue&type=script&lang=js"
export * from "./AddUsersToGroup.vue?vue&type=script&lang=js"

import "./AddUsersToGroup.vue?vue&type=style&index=0&id=008f0984&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008f0984"]])

export default __exports__